export default __webpack_public_path__ + "static/everand_logo-a5b5559ab4f116d2a0fc20e4853382ce.png";